import React from 'react';
import { withTheme } from 'styled-components';
import GameContextDataContainer from '../GameContext/GameContextDataContainer';
import TapStoryContainer from '../TapStory/containers/TapStoryDataContainer';

const PreviewMiniHome = () => {
    return (
        <>
            <TapStoryContainer />
            <GameContextDataContainer gameState='P' />
        </>
    );
};

export default withTheme(PreviewMiniHome);
